/**
 * Browser Better Auth client for the D12 chassis. Server-free — safe in the
 * client bundle. `import { authClient, signIn, useSession } from "@d12labs/auth/client"`.
 */
import { twoFactorClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
	plugins: [
		// Routes the user to /two-factor-verify when sign-in returns a 2FA
		// challenge. Better Auth's client will dispatch this hook from
		// signIn.email when twoFactorRedirect is true in the response.
		twoFactorClient({
			twoFactorPage: "/two-factor-verify",
		}),
	],
});

export const { signIn, signUp, signOut, useSession, twoFactor } = authClient;
